(() => {
  const containers = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = null;

  const clamp = (value) => Math.min(Math.max(value, 0), 1);

  const updateContainer = (container) => {
    if (reducedMotion.matches) {
      container.style.setProperty('--hero-scroll-progress', '1');
      return;
    }

    const rect = container.getBoundingClientRect();
    const scrollRange = Math.max(container.offsetHeight - window.innerHeight, 1);
    const progress = clamp(-rect.top / scrollRange);

    container.style.setProperty('--hero-scroll-progress', progress.toFixed(4));
  };

  const update = () => {
    frame = null;
    containers.forEach(updateContainer);
  };

  const requestUpdate = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(update);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-hero-scroll-reveal]').forEach((container) => {
      containers.add(container);
    });
    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  reducedMotion.addEventListener('change', requestUpdate);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
